import AvailableJobPage from "./AvailableJobPage";

export default AvailableJobPage;